export interface ThankyouPageData {
  assistanceLink: string;
  onWhatsAppClick: () => void;
}

export interface ThankyouPageProps extends ThankyouPageData {}
